import { ModelIdentityMap, IEntityMappingConfig, IServiceBuilderResult, IServiceConfig } from '../..'
import { TypeOf, Utils, BaseModel, DependencyContainer } from '../../..'

export abstract class ServiceBuilder<A, C extends IServiceConfig<A, BaseModel>> {
  protected _configs: Set<C> = new Set<C>()

  public constructor(
    protected _utils: Utils,
    protected _dependencyContainer: DependencyContainer,
    protected _idMap: ModelIdentityMap
  ) {}

  public addServiceConfig(config: C, notify: boolean = true) {
    this._configs.add(config)
    if (notify) { this.onServiceConfigAdded() }
    return this
  }

  public addServiceConfigs(configs: C[]) {
    configs.forEach((config) => this.addServiceConfig(config, false))
    this.onServiceConfigAdded()
    return this
  }

  public setModelIdentityMap(idMap: ModelIdentityMap) {
    this._idMap = idMap
    return this
  }

  public abstract build(): Array<IServiceBuilderResult<A>>
  public abstract buildClass<S extends A>(serviceKlass: TypeOf<S>, serviceDependencies: any[]): IServiceBuilderResult<S>

  protected onServiceConfigAdded() {}

  protected _getServiceClasses(): Array<TypeOf<A>> {
    return this._utils.mapSet(this._configs, (entry) => entry.service)
  }

  protected _getModelClasses(): Array<TypeOf<BaseModel>> {
    return this._utils.mapSet(
      this._configs, (entry: any) => entry.model
    )
  }

  protected _getEndpointMapping(): {[lowerCaseClassName: string]: string} {
    return this._utils.reduceSet<C>(this._configs, (res, entry) => {
      res[entry.model.name.toLowerCase()] = entry.endpoint
      return res
    }, {})
  }

  protected _getEntityMappingConfigs(): IEntityMappingConfig[] {
    return this._utils.mapSet<C, IEntityMappingConfig>(
      this._configs, (entry: any) => entry.mappings || []
    ).reduce((result, arr) => result.concat(arr), []).filter((mapping) => mapping)
  }

  protected _getServiceFactoryMethods(): {[className: string]: () => any} {
    return this._utils.reduceSet<C>(
      this._configs, (result, config) => {
        if (config.useFactory) {
          result[config.model.name] = config.useFactory
        }
        return result
      }, {}
    )
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/model-repository/creators/service-builder/service.builder.ts